import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=510fcaab&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=510fcaab&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510fcaab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510fcaab')) {
      api.createRecord('510fcaab', component.options)
    } else {
      api.reload('510fcaab', component.options)
    }
    module.hot.accept("./NavigationBar.vue?vue&type=template&id=510fcaab&scoped=true", function () {
      api.rerender('510fcaab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/NavigationBar.vue"
export default component.exports